import { SaveButton } from "components/Buttons"
import Table from "components/Table"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import {
  Col,
  Input,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap"
import { getUserList, hideSelectUsersModal, resetUserList } from "store/actions"
import { getUpdatedCheckedItemsList } from "utils"
import usersListColumns from "./usersListColumns"

const SelectUsersModal = ({
  getUserList,
  resetUserList,
  userList,
  vendorId,
  hideSelectUsersModal,
  addUserHandler,
  addedUsers,
}) => {
  const [searchValue, setSearchValue] = useState("")
  const [showResetButton, setShowResetButton] = useState(false)
  const [checkedItems, setCheckedItems] = useState([])
  const [userListData, setUserListData] = useState([])
  const [userListOrder, setUserListOrder] = useState({
    o: "registered_at",
    od: "asc",
  })
  const [resetUserListData, setResetUserListData] = useState(false)

  const handleSearch = () => {
    if (searchValue.trim().length) {
      setUserListData([])
      getUserList({
        include_admins: true,
        m: 25,
        o: userListOrder?.o,
        od: userListOrder?.od,
        page: 1,
        s: searchValue,
        specific_vendor: vendorId,
        vendor_id: vendorId,
      })
      setShowResetButton(true)
    }
  }

  const handleResetSearch = () => {
    setUserListData([])
    getUserList({
      include_admins: true,
      m: 25,
      o: userListOrder?.o,
      od: userListOrder?.od,
      page: 1,
      s: "",
      specific_vendor: vendorId,
      vendor_id: vendorId,
    })
    setSearchValue("")
    setShowResetButton(false)
  }

  useEffect(() => {
    getUserList({
      include_admins: true,
      m: 25,
      o: userListOrder?.o,
      od: userListOrder?.od,
      page: 1,
      s: "",
      specific_vendor: vendorId,
      vendor_id: vendorId,
    })
    return () => {
      resetUserList()
    }
  }, [])

  useEffect(() => {
    if (userList) {
      if (resetUserListData) {
        setUserListData([...userList?.data])
        setResetUserListData(false)
      } else {
        setUserListData([...userListData, ...userList?.data])
      }
    }
  }, [userList])

  const handleSort = (type, { sortField, sortOrder }) => {
    setResetUserListData(true)
    setUserListOrder({ o: sortField, od: sortOrder })
    getUserList({
      o: sortField,
      od: sortOrder,
      page: 1,
      s: searchValue,
      specific_vendor: vendorId,
      vendor_id: vendorId,
      include_admins: true,
      m: 25,
    })
  }

  const handleLoadMore = () => {
    getUserList({
      include_admins: true,
      m: 25,
      o: userListOrder?.o,
      od: userListOrder?.od,
      page: userList?.current_page + 1,
      s: searchValue,
      specific_vendor: vendorId,
      vendor_id: vendorId,
    })
  }

  const handleCheckItem = (item, checked) => {
    let checkedItemsList = getUpdatedCheckedItemsList(
      item,
      checked,
      checkedItems
    )
    setCheckedItems(checkedItemsList)
  }

  const handleCheckAllItems = (items, checked) => {
    let list = []
    if (checked) {
      for (let i = 0; i < items.length; i++) {
        list.push(items[i].id)
      }
    }
    setCheckedItems(list)
  }

  return (
    <React.Fragment>
      <ModalHeader>Select users</ModalHeader>
      <ModalBody>
        <Row className="d-flex justify-content-center">
          <Col xs="auto">
            <Input
              value={searchValue}
              onChange={event => {
                setSearchValue(event.target.value)
              }}
              placeholder="Search"
            />
          </Col>
          <Col xs="auto">
            <SaveButton type="button" content="Search" onClick={handleSearch} />
          </Col>
          {showResetButton && (
            <Col xs="auto">
              <SaveButton
                type="button"
                content="Reset"
                color="light"
                onClick={handleResetSearch}
              />
            </Col>
          )}
        </Row>
        <Row className="mt-3">
          <Col>
            <Table
              columns={usersListColumns()}
              data={userListData.filter(user => !addedUsers?.includes(user.id))}
              onTableSort={handleSort}
              withCheckboxes={true}
              onCheckItem={handleCheckItem}
              onCheckAllItems={handleCheckAllItems}
            />
          </Col>
        </Row>
        {userList?.current_page < userList?.last_page && (
          <Row className="d-flex justify-content-center">
            <Col xs="auto">
              <SaveButton
                type="button"
                content="Load more users"
                color="light"
                onClick={handleLoadMore}
              />
            </Col>
          </Row>
        )}
      </ModalBody>
      <ModalFooter>
        <Row className="d-flex justify-content-end">
          <Col xs="auto">
            <SaveButton
              type="button"
              content="Cancel"
              onClick={hideSelectUsersModal}
              color="danger"
            />
          </Col>
          <Col xs="auto">
            <SaveButton
              type="button"
              content="Add to list"
              onClick={() => {
                addUserHandler(
                  userListData.filter(user => checkedItems.includes(user.id))
                )
              }}
              disabled={checkedItems.length === 0}
            />
          </Col>
        </Row>
      </ModalFooter>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  userList: state.ContactUsScreen.userList,
  vendorId: state.Login.clientConfig.vendor_id,
})

const mapDispatchToProps = dispatch => ({
  getUserList: values => dispatch(getUserList(values)),
  resetUserList: () => dispatch(resetUserList()),
  hideSelectUsersModal: () => dispatch(hideSelectUsersModal()),
})

export default connect(mapStateToProps, mapDispatchToProps)(SelectUsersModal)
